import SelectFieldMultiple from '../shared/SelectFieldMultiple'
import { POOL_OPTIONS } from 'store/CreatePropertyAdSlice/constants'
import React from 'react'
import {
  useWatch,
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues?: UseFormGetValues<FormValues>
  resetField?: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const Pool = (props: Props) => {
  const { t } = useTranslation()
  const { control } = props

  const watchCategory = useWatch({ control, name: 'step1.category' })

  const formatter = (items: typeof POOL_OPTIONS) => {
    const filtered = POOL_OPTIONS.filter((option) =>
      items.includes(option.value as unknown as typeof POOL_OPTIONS[number])
    )
    return filtered.map((type) => ` ${t(type.label)}`).join(', ')
  }

  const IS_REQUIRED = watchCategory === 'commercial'

  return (
    <>
      <SelectFieldMultiple
        options={POOL_OPTIONS}
        title="createPropertyAdFields.pool.label"
        translateTitle
        titleProps={{ required: IS_REQUIRED }}
        formatter={formatter}
        control={control}
        name={'property.pool' as Path<FormValues>}
      />
    </>
  )
}

export default React.memo(Pool)
